export const STATUS_MAP = {
  cho_duyet: {
    label: "Chờ duyệt",
    color: "#faad14",
    bg: "#fff7e6",
  },
  da_duyet: {
    label: "Đã duyệt",
    color: "#389e0d",
    bg: "#f6ffed",
  },
  huy: {
    label: "Đã hủy",
    color: "#cf1322",
    bg: "#fff1f0",
  },
};
